import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import "./Menu.css";

const handleOpenPDF = () => {
  // Fenster sofort öffnen – synchron!
  const newWindow = window.open("", "_blank");

  // Dann PDF asynchron laden
  import("../assets/speisekarte.pdf").then((pdf) => {
    if (newWindow) {
      newWindow.location.href = pdf.default;
    }
  });
};

const Menu = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setShowButton(window.scrollY > 200);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <>
      <Helmet>
        {/* Basisinformationen */}
        <title>
          Speisekarte | Pizzeria 480 Grad – Neapolitanische Pizza in Nürnberg
        </title>
        <meta
          name="description"
          content="Entdecke die original neapolitanische Pizza bei 480 Grad in Nürnberg – hausgemacht, vegan & mit hochwertigen Zutaten. Jetzt Speisekarte ansehen!"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.480gradpizza.de/menu" />
        {/* Open Graph (Facebook, WhatsApp, LinkedIn) */}
        <meta
          property="og:title"
          content="Pizzeria 480 Grad – Unsere Speisekarte"
        />
        <meta
          property="og:description"
          content="Leckere neapolitanische Pizza, vegane Alternativen, Cocktails und Desserts – entdecke unsere Speisekarte."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.480gradpizza.de/menu" />
        <meta
          property="og:image"
          content="https://www.480gradpizza.de/pizza4.png"
        />{" "}
        {/* Bild für Social Sharing */}
        <meta property="og:site_name" content="Pizzeria 480 Grad" />
        {/* Twitter Cards (optional) */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Pizzeria 480 Grad – Unsere Speisekarte"
        />
        <meta
          name="twitter:description"
          content="Unsere hausgemachte neapolitanische Pizza & kreative Drinks – jetzt entdecken!"
        />
        <meta
          name="twitter:image"
          content="https://www.480gradpizza.de/pizza4.png"
        />
        {/* Lokales SEO (optional) */}
        <meta name="geo.region" content="DE-BY" />
        <meta name="geo.placename" content="Nürnberg" />
        <meta name="geo.position" content="49.451699;11.069709" />
        <meta name="ICBM" content="49.451699, 11.069709" />
      </Helmet>
      <main className="menu-page">
        <h1>Unsere Speisekarte</h1>
        <button className="hero-btn" onClick={handleOpenPDF}>
          PDF Speisekarte
        </button>
        <nav className="menu-nav">
          <ul>
            <li>
              <a href="#starter">STARTER</a>
            </li>
            <li>
              <a href="#salate">SALATE</a>
            </li>
            <li>
              <a href="#pizza">PIZZA</a>
            </li>
            <li>
              <a href="#vegane-pizza">VEGANE PIZZA</a>
            </li>
            <li>
              <a href="#crust-dips">CRUST DIPS</a>
            </li>
            <li>
              <a href="#add-ons">ADD-ONS</a>
            </li>
            <li>
              <a href="#desserts">DESSERTS</a>
            </li>
            <li>
              <a href="#softdrinks">SOFTDRINKS</a>
            </li>
            <li>
              <a href="#kaffee-und-tee">KAFFEE UND TEE</a>
            </li>
            <li>
              <a href="#bier">BIER</a>
            </li>
            <li>
              <a href="#white-wine">WHITE WINE</a>
            </li>
            <li>
              <a href="#rose">ROSÉ</a>
            </li>
            <li>
              <a href="#rosso">ROSSO</a>
            </li>
            <li>
              <a href="#sprizz">SPRIZZ</a>
            </li>
            <li>
              <a href="#cocktails">HIGHBALLS/COCKTAILS</a>
            </li>
            <li>
              <a href="#shots">SHOTS</a>
            </li>
          </ul>
        </nav>

        <section id="starter" className="menu-section">
          <h2>STARTER</h2>
          <div className="menu-items">
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">HAUSGEMACHTES PIZZABROT</span>
                <span className="item-price">7 €</span>
              </div>
              <div className="item-description">
                HOMEMADE KNOBLAUCHÖL, OREGANO
              </div>
              <span className="item-price">+CRUST DIP 3 €</span>
              <span className="item-price">+CUP OLIVES 3 €</span>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">BRUSCHETTA ALLA NAPOLI</span>
                <span className="item-price">9 €</span>
              </div>
              <div className="item-description">
                FEIN GEHACKTE TOMATEN IN KNOBLAUCHÖL, OREGANO, DAZU PIZZABROT
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">CARPACCIO DI BRESAOLA</span>
                <span className="item-price">12 €</span>
              </div>
              <div className="item-description">
                BRESAOLA AUS KAMPANIEN, RUCOLA, GRANA PADANO, ZITRONENÖL DAZU
                HAUSGEMACHTES PIZZABROT
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">CAPRESE 480°</span>
                <span className="item-price">12 €</span>
              </div>
              <div className="item-description">
                BÜFFELMOZZARELLA AUS KAMPANIEN D.O.P, EINGELEGTE KIRSCHTOMATEN,
                BALSAMICOCRÈME, OLIVE OIL EXTRA VERGINE, FRISCHER BASILIKUM DAZU
                HAUSGEMACHTES PIZZABROT
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">CAPRESE VEGAN</span>
                <span className="item-price">12 €</span>
              </div>
              <div className="item-description">
                EINGELEGTE KIRSCHTOMATEN, VEGANE FETA, BALSAMICO CRÈME, OLIVE
                OIL EXTRA VERGINE, FRISCHER BASILIKUM DAZU HAUSGEMACHTES
                PIZZABROT
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">ANTIPASTI PLATTE</span>
                <span className="item-price">15 €</span>
              </div>
              <div className="item-description">
                DIVERSE SALAMI UND KÄSESORTEN, OLIVEN, GEGRILLTES GEMÜSE DER
                SAISON DAZU HAUSGEMACHTES PIZZABROT
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">BURRATA BOMB</span>
                <span className="item-price">10 €</span>
              </div>
              <div className="item-description">
                FRISCHE BURRATA AUS APULIEN, FRISCHE RUCOLA & KIRSCHTOMATEN,
                DAZU PIZZABROT
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">BURRATA TARTUFO</span>
                <span className="item-price">12 €</span>
              </div>
              <div className="item-description">
                FRISCHE BURRATA AUS APULIEN, TRÜFFELCRÈME, FRISCHE RUCOLA &
                KIRSCHTOMATEN, DAZU PIZZABROT
              </div>
            </div>
          </div>
        </section>

        <section id="salate" className="menu-section">
          <h2>SALATE</h2>
          <div className="menu-items">
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">SIDE SALAD</span>
                <span className="item-price">7 €</span>
              </div>
              <div className="item-description">
                FRISCHER BLATTSALAT, ZWIEBEL, FRISCHE KIRSCHTOMATEN, OLIVEN AUS
                GAETA, HAUSDRESSING
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">AVOCADO</span>
                <span className="item-price">10 €</span>
              </div>
              <div className="item-description">
                FRISCHER BLATTSALAT, FRISCHE KIRSCHTOMATEN, ROTE ZWIEBEL,
                AVOCADO, OLIVE OIL, BALSAMICO CREME
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">ITALIAN SUMMER</span>
                <span className="item-price">10 €</span>
              </div>
              <div className="item-description">
                FRISCHER BLATTSALAT, FRISCHER BÜFFELMOZZARELLA, KÜRBISKERNE,
                FRISCHE KIRSCHTOMATEN, BALSAMICO CRÈME, GRANA PADANO 14 MONATE
                GEREIFT
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">BURRATA</span>
                <span className="item-price">10 €</span>
              </div>
              <div className="item-description">
                RUCOLA, FRISCHE BURRATA AUS APULIEN, KÜRBISKERNE, FRISCHE
                KIRSCHTOMATEN, BALSAMICO CRÈME, GRANA PADANO 14 MONATE GEREIFT
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">VEGAN FETA</span>
                <span className="item-price">10 €</span>
              </div>
              <div className="item-description">
                FRISCHER BLATTSALAT, VEGAN FETA, FRISCHE KIRSCHTOMATEN, ROTE
                ZWIEBELN, OLIVEN AUS GAETA, HAUSDRESSING
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">TUNA SALAT</span>
                <span className="item-price">10 €</span>
              </div>
              <div className="item-description">
                FRISCHER BLATTSALAT, THUNFISCH, ZWIEBEL, FRISCHE KIRSCHTOMATEN,
                OLIVEN AUS GAETA, HAUSDRESSING
              </div>
            </div>
          </div>
        </section>
        {showButton && (
          <button
            className="scroll-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            ^
          </button>
        )}
        <section id="pizza" className="menu-section">
          <h2>PIZZA</h2>
          <div className="menu-items">
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">MARGHERITA</span>
                <span className="item-price">11 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, FRISCHE FIOR DʼAGEROLA MOZZARELLA D.O.P,
                OREGANO, PECORINO D.O.P, OLIVE OIL EXTRA VERGINE, FRISCHER
                BASILIKUM
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">SALAME NAPOLI</span>
                <span className="item-price">13 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, FRISCHE FIOR DʼAGEROLA MOZZARELLA D.O.P,
                SALAMI NAPOLI, PECORINO D.O.P, FRISCHER BASILIKUM
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">PARMA 24M</span>
                <span className="item-price">16 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, FRISCHE FIOR DʼAGEROLA MOZZARELLA D.O.P,
                PARMASCHINKEN 24 MONATE GEREIFT, FRISCHE KIRSCHTOMATEN, GRANA
                PADANO 14 MONATE GEREIFT, FRISCHE RUCOLA, OLIVE OIL EXTRA
                VERGINE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">FUNKY TUNA</span>
                <span className="item-price">14 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, FRISCHE FIOR DʼAGEROLA MOZZARELLA D.O.P,
                TUNA, ROTE ZWIEBELN, OREGANO, OLIVE OIL EXTRA VERGINE, FRISCHER
                BASILIKUM
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">GEMÜSEFREUNDE</span>
                <span className="item-price">14 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, FRISCHE FIOR DʼAGEROLA MOZZARELLA D.O.P,
                GEGRILLTE AUBERGINE, ZUCCHINI & PAPRIKA, FRISCHE RUCOLA,
                BALSAMICOCRÉME
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">AMORE MIO</span>
                <span className="item-price">14 €</span>
              </div>
              <div className="item-description">
                SAHNEBODEN, FRISCHE FIOR DʼAGEROLA MOZZARELLA D.O.P, FRISCHE
                CHAMPIGNONS, HINTERSCHINKEN AUS ITALIEN, OLIVE OIL EXTRA
                VERGINE, FRISCHER BASILIKUM
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">SMASHED BUFALA</span>
                <span className="item-price">15 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, FRISCHE FIOR DʼAGEROLA MOZZARELLA D.O.P,
                SMASHED BÜFFELMOZZARELLA, RUCOLA, FRISCHE KIRSCHTOMATEN, OLIVE
                OIL EXTRA VERGINE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">HOLY GUACAMOLE</span>
                <span className="item-price">16 €</span>
              </div>
              <div className="item-description">
                AVOCADOCRÉME, FRISCHE FIOR DʼAGEROLA MOZZARELLA D.O.P, SMASHED
                BÜFFELMOZZARELLA, RUCOLA, FRISCHE KIRSCHTOMATEN, OLIVE OIL EXTRA
                VERGINE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">BURRATA</span>
                <span className="item-price">15 €</span>
              </div>
              <div className="item-description">
                SAHNEBODEN, FRISCHE FIOR DʼAGEROLA MOZZARELLA D.O.P, FRISCHE
                BURRATA AUS APULIEN, GRANA PADANO 14 MONATE GEREIFT, RUCOLA,
                OLIVE OIL EXTRA VERGINE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">IN LOVE WITH CHEESE</span>
                <span className="item-price">15 €</span>
              </div>
              <div className="item-description">
                SAHNEBODEN, FRISCHE FIOR DʼAGEROLA MOZZARELLA D.O.P, PECORINO
                D.O.P, GORGONZOLA D.O.P, PROVOLA, FRISCHER BÜFFELMOZZARELLA
                D.O.P, GRANA PADANO 14 MONATE GEREIFT, OLIVE OIL EXTRA VERGINE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">SALSICCIA E FRIARIELLI</span>
                <span className="item-price">14 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, FRISCHE FIOR DʼAGEROLA MOZZARELLA D.O.P,
                FRIARIELLI (STÄNGELKOHL), FRISCHE SALSICCIA, PECORINO D.O.P,
                KNOBLAUCHÖL
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">INFERNO</span>
                <span className="item-price">15 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, FRISCHE FIOR DʼAGEROLA MOZZARELLA D.O.P,
                FRISCHE BURRATA AUS APULIEN, SCHARFE SALAMI (SPIANATA), OLIVE
                OIL EXTRA VERGINE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">480</span>
                <span className="item-price">16 €</span>
              </div>
              <div className="item-description">
                SAHNEBODEN, FRISCHE FIOR DʼAGEROLA MOZZARELLA D.O.P, GRANA
                PADANO 14 MONATE GEREIFT, FRISCHE KIRSCHTOMATEN, BRESAOLA
                (RINDERSCHINKEN) AUS NEAPEL, RUCOLA, BIO ZITRONENÖL
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">TRÜFFEL</span>
                <span className="item-price">16 €</span>
              </div>
              <div className="item-description">
                TRÜFFELCRÈME, FIOR DʼAGEROLA MOZZARELLA D.O.P, FRISCHE
                KIRSCHTOMATEN, RUCOLA, OLIVE OIL EXTRA VERGINE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">MR. BURNS</span>
                <span className="item-price">15 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, FIOR DʼAGEROLA MOZZARELLA D.O.P, NDUJA
                (SCHARF), SPIANATA SALAMI (SCHARF), FRISCHER BASILIKUM, OLIVE
                OIL EXTRA VERGINE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">TURKISH DELIGHT</span>
                <span className="item-price">14 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, FRISCHE FIOR DʼAGEROLA MOZZARELLA D.O.P,
                FRISCHE KNOBLAUCHWURST (SUCUK), MARINIERTE OLIVEN AUS GAETA,
                OLIVE OIL EXTRA VERGINE, FRISCHER BASILIKUM
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">PESTO GRÜN</span>
                <span className="item-price">14 €</span>
              </div>
              <div className="item-description">
                HOMEMADE PESTO AUS RUCOLA, BASILIKUM UND PINIENKERNEN, FRISCHE
                FIOR DʼAGEROLA MOZZARELLA D.O.P, FRISCHE KIRSCHTOMATEN,
                PINIENKERNE, OLIVE OIL EXTRA VERGINE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">PESTO ROSSO</span>
                <span className="item-price">14 €</span>
              </div>
              <div className="item-description">
                HOMEMADE PESTO AUS GETROCKNETEN TOMATEN UND WALLNUSS, FRISCHE
                FIOR DʼAGEROLA MOZZARELLA D.O.P, FRISCHE KIRSCHTOMATEN,
                KÜRBISKERNE, OLIVE OIL EXTRA VERGINE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">PARMEGIANA</span>
                <span className="item-price">14 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, FIOR DʼAGEROLA MOZZARELLA D.O.P, EINGELEGTE
                AUBERGINE, PARMIGIANO REGGIANO, OREGANO, OLIVE OIL EXTRA VERGINE
              </div>
            </div>
          </div>
        </section>

        <section id="vegane-pizza" className="menu-section">
          <h2>VEGANE PIZZA</h2>
          <div className="menu-items">
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">LEGALIZE MARINARA</span>
                <span className="item-price">9 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, KNOBLAUCHÖL, OREGANO, FRISCHER BASILIKUM
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">PARMEGIANA</span>
                <span className="item-price">14 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, VEGAN BÜFFELMOZZARELLA, EINGELEGTE
                AUBERGINE, OREGANO, OLIVE OIL EXTRA VERGINE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">MARGHERITA</span>
                <span className="item-price">12 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, VEGAN BÜFFELMOZZARELLA, OREGANO, OLIVE OIL
                EXTRA VERGINE, FRISCHER BASILIKUM
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">MAGIC MUSHROOM</span>
                <span className="item-price">14 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, VEGAN BÜFFELMOZZARELLA, FRISCHE
                CHAMPIGNONS, OLIVE OIL EXTRA VERGINE, FRISCHER BASILIKUM
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">PESTO GRÜN</span>
                <span className="item-price">14 €</span>
              </div>
              <div className="item-description">
                HOMEMADE RUCOLA PESTO, VEGAN BÜFFELMOZZARELLA, FRISCHE
                KIRSCHTOMATEN, PINIENKERNE, OLIVE OIL EXTRA VERGINE, FRISCHER
                BASILIKUM
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">PESTO ROSSO</span>
                <span className="item-price">14 €</span>
              </div>
              <div className="item-description">
                HOMEMADE PESTO AUS GETROCKNETEN TOMATEN UND WALNUSS, VEGAN
                BÜFFELMOZZARELLA, FRISCHE KIRSCHTOMATEN, KÜRBISKERNE, OLIVE OIL
                EXTRA VERGINE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">NO CHORIZO</span>
                <span className="item-price">15 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, VEGAN BÜFFELMOZZARELLA, VEGAN CHORIZO,
                KÜRBISKERNE, ROTE CHILLI, OLIVE OIL EXTRA VERGINE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">SALSICCIA E FRIARIELLI</span>
                <span className="item-price">15 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, VEGAN BÜFFELMOZZARELLA, FRIARIELLI
                (STÄNGELKOHL), VEGAN SALSICCIA, FRISCHER BASILIKUM, OLIVE OIL
                EXTRA VERGINE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">SALAME</span>
                <span className="item-price">14 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, VEGAN BÜFFELMOZZARELLA, VEGAN SALAMI,
                FRISCHER BASILIKUM, OLIVE OIL EXTRA VERGINE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">TRÜFFEL</span>
                <span className="item-price">16 €</span>
              </div>
              <div className="item-description">
                TRÜFFELCRÈME, VEGAN BÜFFELMOZZARELLA, FRISCHE KIRSCHTOMATEN,
                RUCOLA, OLIVE OIL EXTRA VERGINE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">GEMÜSEFREUNDE</span>
                <span className="item-price">15 €</span>
              </div>
              <div className="item-description">
                SAN MARZANO TOMATEN, VEGAN BÜFFELMOZZARELLA, GEGRILLTE
                AUBERGINE, ZUCCHINI UND PAPRIKA, BALSAMICOCRÉME, OLIVE OIL EXTRA
                VERGINE, FRISCHE RUCOLA
              </div>
            </div>
          </div>
        </section>

        <section id="crust-dips" className="menu-section">
          <h2>CRUST DIPS</h2>
          <div className="menu-items">
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">AIOLI (VEGAN)</span>
                <span className="item-price">3 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">TRÜFFELMAYO (VEGAN)</span>
                <span className="item-price">3 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">GRÜNE PESTO (VEGAN)</span>
                <span className="item-price">3 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">ROTE PESTO (VEGAN)</span>
                <span className="item-price">3 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">SRIRACHA MAYO</span>
                <span className="item-price">3 €</span>
              </div>
            </div>
          </div>
        </section>

        <section id="add-ons" className="menu-section">
          <h2>ADD-ONS</h2>
          <div className="menu-items">
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">
                  PARMA | BURRATA | BÜFFELMOZZARELLA | BRESAOLAd
                </span>
                <span className="item-price">3,50 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">
                  SPIANATA | D.O.P MOZZARELLA | NDUJA (SPICY STREICHWURST)
                  SALSICCIA{" "}
                </span>
                <span className="item-price">3 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">
                  VEGAN SALAMI | VEGAN CHORIZO | AUBERGINE | ZUCCHINI
                </span>
                <span className="item-price">3 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name"> PAPRIKA | MARINIERTE OLIVEN</span>
                <span className="item-price">3 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">
                  GRANA PADANO | RUCOLA | KIRSCHTOMATEN | CHAMPIGNONS |
                  ZWIEBEL{" "}
                </span>
                <span className="item-price">2,50 €</span>
              </div>
            </div>
          </div>
        </section>

        <section id="desserts" className="menu-section">
          <h2>DESSERTS</h2>
          <div className="menu-items">
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">NONAS TIRAMISU</span>
                <span className="item-price">7 €</span>
              </div>
              <div className="item-description">
                HOMEMADE TIRAMISU MIT VIEL AMORE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">NUTELLA PIZZA</span>
                <span className="item-price">9 €</span>
              </div>
              <div className="item-description">
                NUTELLA MIT PUDERZUCKER (vegan +2 €)
              </div>
            </div>
          </div>
        </section>

        <section id="softdrinks" className="menu-section">
          <h2>SOFTDRINKS</h2>
          <div className="menu-items">
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">AQUA LAUT/LEISE</span>
                <span className="item-price">
                  0.3L 3.5 €&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1L 6 €
                </span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">PEPSI</span>
                <span className="item-price">0.5L 4 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">PEPSI ZERO</span>
                <span className="item-price">0.5L 4 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">MIRINDA</span>
                <span className="item-price">0.5L 4 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">7UP</span>
                <span className="item-price">0.5L 4 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">SPEZI</span>
                <span className="item-price">0.5L 4 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">APFELSCHORLE</span>
                <span className="item-price">0.5L 4 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">MARACUJASCHORLE</span>
                <span className="item-price">0.5L 4 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">JOHANNISBEERSCHORLE</span>
                <span className="item-price">0.5L 4 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">MANGOSCHORLE</span>
                <span className="item-price">0.5L 4 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">FRISCH GEPRESSTER ORANGENSAFT</span>
                <span className="item-price">0.5L 5 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">BLUTORANGE-KIWI-LEMONADE</span>
                <span className="item-price">0.5L 6 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">ANANAS-MANGO-LEMONADE</span>
                <span className="item-price">0.5L 6 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">CITRUS-HIMBEER-LEMONADE</span>
                <span className="item-price">0.5L 6 €</span>
              </div>
            </div>
          </div>
        </section>

        <section id="kaffee-und-tee" className="menu-section">
          <h2>KAFFEE UND TEE</h2>
          <div className="menu-items">
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">ESPRESSO</span>
                <span className="item-price">2,50 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">DOPPELTER ESPRESSO</span>
                <span className="item-price">3,50 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">FREDO ESPRESSO</span>
                <span className="item-price">4 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">KAFFEE CREMA</span>
                <span className="item-price">3 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">CAPPUCINO</span>
                <span className="item-price">3,50 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">FREDO CAPPUCINO</span>
                <span className="item-price">4,50 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">LATTE MACCHIATO</span>
                <span className="item-price">4 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">ICED AMERICANO</span>
                <span className="item-price">4 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">ICED ESPRESSO TONIC</span>
                <span className="item-price">5 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">COLD BREW</span>
                <span className="item-price">4 €</span>
              </div>
              <div className="item-description">
                MILCHALTERNATIVEN: HAFER + 0,50 €
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">GRÜN</span>
                <span className="item-price">3,50 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">MINZE</span>
                <span className="item-price">3,50 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">INGWER ZITRONE</span>
                <span className="item-price">3,50 €</span>
              </div>
            </div>
          </div>
        </section>

        <section id="bier" className="menu-section">
          <h2>BIER</h2>
          <div className="menu-items">
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">GRÜNER HELL</span>
                <span className="item-price">0.50L 5 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">GRÜNER RADLER</span>
                <span className="item-price">0.50L 4.5 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">LEDERER PILS</span>
                <span className="item-price">0.40L 4.5 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">TUCHER WEIZEN</span>
                <span className="item-price">0.50L 5 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">TUCHER ALKOHOLFREI</span>
                <span className="item-price">0.50L 4.5 €</span>
              </div>
            </div>
          </div>
        </section>

        <section id="white-wine" className="menu-section">
          <h2>WHITE WINE</h2>
          <div className="menu-items">
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">PINOT GRIGIO BORGO CONVENTI</span>
                <span className="item-price">
                  0.20L 6 €&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0.70L 20 €
                </span>
              </div>
              <div className="item-description">
                BIRNE, WEIßE BLÜTEN – ITALIEN
              </div>
            </div>

            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">CUVEE VALDELAGUNDE</span>
                <span className="item-price">
                  0.20L 7 € &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 0.70L 25
                  €
                </span>
              </div>
              <div className="item-description">
                MANGO, PFIRSICH, ZITRONE, ANANAS, VANILLE – SPANIEN
              </div>
            </div>

            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">CHATEAU BLANC ARROGANT FROG</span>
                <span className="item-price">
                  0.20L 8 €&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0.70L 30 €
                </span>
              </div>
              <div className="item-description">
                MANGO, BRIOCHE, APRIKOSE, WALNUSS – FRANKREICH
              </div>
            </div>

            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">CHARDONNAY PROMISED LAND</span>
                <span className="item-price">
                  0.20L 7 €&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0.70L 25 €
                </span>
              </div>
              <div className="item-description">
                ANANAS, ZITRONE, BIRNE, VANILLE – AUSTRALIEN
              </div>
            </div>

            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">LUGANA LE CIVAIE</span>
                <span className="item-price">
                  0.20L 8 €&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0.70L 30 €
                </span>
              </div>
              <div className="item-description">
                VANILLE, WEIßER PFEFFER, BLÜTEN
              </div>
            </div>

            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">WEINSCHORLE</span>
                <span className="item-price">0.20L 6 €</span>
              </div>
            </div>

            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">PROSECCO SCAVI & RAY</span>
                <span className="item-price">
                  0.20L 4 €&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0.70L 25 €
                </span>
              </div>
            </div>
          </div>
        </section>

        <section id="rose" className="menu-section">
          <h2>ROSÉ</h2>
          <div className="menu-items">
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">ROSADO PABLO CARLO </span>
                <span className="item-price">
                  0.2OL 6 €&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0.70L 20 €
                </span>
              </div>
              <div className="item-description">
                BROMBEERE, GRAPEFRUIT, RHABARBER - SPANIEN
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">WHISPERING ANGEL THE PALE</span>
                <span className="item-price">
                  0.2OL 8 € &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 0.70L 30
                  €
                </span>
              </div>
              <div className="item-description">
                ERDBEERE, KIRSCHE, WEIßER PFIRSICH - FRANKREICH
              </div>
            </div>
          </div>
        </section>

        <section id="rosso" className="menu-section">
          <h2>ROSSO</h2>
          <div className="menu-items">
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">PRIMITIVO PIETRA PURA MANDUS </span>
                <span className="item-price">
                  0.2OL 7 €&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0.70L 25 €
                </span>
              </div>
              <div className="item-description">
                SAUERKIRSCHE, VANILLE, HOLZ - ITALIEN
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">SHIRAZ PROMISED LAND</span>
                <span className="item-price">
                  0.2OL 7 €&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0.70L 25 €
                </span>
              </div>
              <div className="item-description">
                BROMBEERE, PFLAUME, VANILLE - AUSTRALIEN
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">
                  CABERNET SAUVIGNON ARROGANT FROG
                </span>
                <span className="item-price">
                  0.2OL 8 €&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0.70L 30 €
                </span>
              </div>
              <div className="item-description">
                NUSS, BEERE, SCHOKOLADE - FRANKREICH
              </div>
            </div>
          </div>
        </section>

        <section id="sprizz" className="menu-section">
          <h2>SPRIZZ</h2>
          <div className="menu-items">
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">LILLET WILDBERRY</span>
                <span className="item-price">8 €</span>
              </div>
              <div className="item-description">
                LILLET | GOLDBERG WILD BERRY
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">APEROL</span>
                <span className="item-price">8 €</span>
              </div>
              <div className="item-description">APEROL | SECCO | SODA</div>
            </div>

            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">APEROL PASSIONSFRUCHT</span>
                <span className="item-price">8 €</span>
              </div>
              <div className="item-description">
                APEROL | PASSIONSFRUCHT | SECCO | SODA
              </div>
            </div>

            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">GREENY</span>
                <span className="item-price">8 €</span>
              </div>
              <div className="item-description">
                DER GREENY BESTEHT AUS 31 ZUTATEN <br />
                U.A. VANILLE | KAMILLE | INGWER | SÜSSE ORANGEN UND ABSINTH |
                SECCO | SODA
              </div>
            </div>

            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">CAMPARI AMALFI</span>
                <span className="item-price">8 €</span>
              </div>
              <div className="item-description">
                CAMPARI | SECCO | SODA | FRISCHE ORANGE
              </div>
            </div>

            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">LIMONCELLO</span>
                <span className="item-price">8 €</span>
              </div>
              <div className="item-description">LIMONCELLO | SECCO | SODA</div>
            </div>

            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">LIMONCELLO BERRY</span>
                <span className="item-price">8 €</span>
              </div>
              <div className="item-description">
                LIMONCELLO | ERDBEERE | SECCO | SODA
              </div>
            </div>

            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">SARTI</span>
                <span className="item-price">8 €</span>
              </div>
              <div className="item-description">SARTI | SECCO | SODA</div>
            </div>
          </div>
        </section>

        <section id="cocktails" className="menu-section">
          <h2>HIGHBALLS/COCKTAILS</h2>
          <div className="menu-items">
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">VODKA BERRY</span>
                <span className="item-price">10 €</span>
              </div>
              <div className="item-description">
                ORGANIC VODKA | GOLDBERG BERRY | LIME
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">VODKA REDBULL</span>
                <span className="item-price">10 €</span>
              </div>
              <div className="item-description">ORGANIC VODKA | REDBULL</div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">SKINNY B*TCH</span>
                <span className="item-price">10 €</span>
              </div>
              <div className="item-description">
                ORGANIC VODKA | LIME | SODA
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">WHISKEY COLA</span>
                <span className="item-price">10 €</span>
              </div>
              <div className="item-description">MAKERS MARK WHISKEY | COLA</div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">GIN TONIC</span>
                <span className="item-price">10 €</span>
              </div>
              <div className="item-description">GIN | GOLDBERG TONIC WATER</div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">GIN FIZZ</span>
                <span className="item-price">10 €</span>
              </div>
              <div className="item-description">
                LONDON DRY GIN | LIME | ZUCKERSIRUP | SODA
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">MOSCOW MULE</span>
                <span className="item-price">11 €</span>
              </div>
              <div className="item-description">
                ORGANIC VODKA | GINGER BEER | LIME | FRISCHE MINZE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">PORNSTAR MARTINI</span>
                <span className="item-price">11 €</span>
              </div>
              <div className="item-description">
                ORGANIC VODKA | PASSIONSFRUCHT | LIME | VANILLE
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">ESPRESSO MARTINI</span>
                <span className="item-price">11 €</span>
              </div>
              <div className="item-description">
                ORGANIC VODKA | ESPRESSO DOPIO | KAHLUA | ZUCKERSIRUP
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">WHISKEY SOUR</span>
                <span className="item-price">11 €</span>
              </div>
              <div className="item-description">
                MAKERS MARK WHISKEY | FRISCHE ZITRONE | ZUCKERSIRUP
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">BASIL SMASH</span>
                <span className="item-price">11 €</span>
              </div>
              <div className="item-description">
                LONDON DRY GIN | FRISCHER BASILIKUM | ZUCKERSIRUP | LIME
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">CAIPIRINHA</span>
                <span className="item-price">11 €</span>
              </div>
              <div className="item-description">
                CACHACA | FRISCHE LIMETTEN | BRAUNER ZUCKER | SODA
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">MOJITO</span>
                <span className="item-price">11 €</span>
              </div>
              <div className="item-description">
                WEISSER RUM | LIME | ROHRZUCKER | FRISCHE MINZE | SODA
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">TOUCH DOWN</span>
                <span className="item-price">11 €</span>
              </div>
              <div className="item-description">
                ORGANIC VODKA | APRICOT BRANDY | LIME | GRENADINE | MARACUJASAFT
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">VIVA CUBA LIBRE</span>
                <span className="item-price">11 €</span>
              </div>
              <div className="item-description">
                WEISSER RUM | COLA | FRISCHE LIMETTEN
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">SEX ON THE BEACH</span>
                <span className="item-price">11 €</span>
              </div>
              <div className="item-description">
                ORGANIC VODKA | PEACH TREE | GRENADINE | ORANGENSAFT |
                ANANASSAFT
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">LONG ISLAND ICETEE</span>
                <span className="item-price">11 €</span>
              </div>
              <div className="item-description">
                ORGANIC VODKA | LONDON DRY GIN | TEQUILA | WEISSER RUM | LIME |
                COINTREAU | ZUCKERSIRUP | COLA
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">MAI THAI CLASSIC</span>
                <span className="item-price">13 €</span>
              </div>
              <div className="item-description">
                WEISSER RUM | BRAUNER RUM | OLD PASCAS 73% | TRIPLE SEC |
                MANDELSIRUP | ZUCKERSIRUP
              </div>
            </div>
          </div>
        </section>

        <section id="shots" className="menu-section">
          <h2>SHOTS</h2>
          <div className="menu-items">
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">LIMOCELLO</span>
                <span className="item-price">2CL &nbsp;&nbsp;3 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">VODKALIME</span>
                <span className="item-price">2CL &nbsp;&nbsp;3 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">BRAINSHOT</span>
                <span className="item-price">2CL &nbsp;&nbsp;3 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">AMARETTO</span>
                <span className="item-price">2CL &nbsp;&nbsp;3 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">SAMBUCA</span>
                <span className="item-price">2CL &nbsp;&nbsp;3 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">LIQUID COCAINE</span>
                <span className="item-price">2CL &nbsp;&nbsp;3 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">TEQUILA</span>
                <span className="item-price">2CL &nbsp;&nbsp;3 €</span>
              </div>
            </div>
            <div className="menu-item">
              <div className="item-header">
                <span className="item-name">ERDBEERLIME</span>
                <span className="item-price">2CL &nbsp;&nbsp;3 €</span>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Menu;
